import TherapistTable from './TherapistTable'
export default TherapistTable
